import axios from 'axios'
import qs from 'qs'
import URI from 'urijs'
import Vue from 'vue'

// Production configuration
axios.defaults.baseURL = 'https://api.leverade.com'
axios.defaults.headers.common['Accept'] = 'application/vnd.api+json'
axios.defaults.paramsSerializer = (params) => {
  return qs.stringify(params, { arrayFormat: 'brackets' })
}

// Development overwritten configuration
if (document.domain !== 'widgets.leverade.com') {
  const params = qs.parse((new URI()).query())

  axios.defaults.baseURL = params.api_url || axios.defaults.baseURL
}

Vue.use({
  install (Vue) {
    Vue.prototype.$axios = axios
  },
})



// WEBPACK FOOTER //
// ./src/server/plugins/axios.js